import { Fragment } from 'react';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { AdditionalSectionItem } from './PrivacyRightsWrapper.types';

export const PrivacyRightsAdditionalSection = ({
  additionalSection,
}: {
  additionalSection: AdditionalSectionItem[];
}) => {
  return (
    <Fragment>
      {additionalSection.map(item => (
        <LegalTextWithLink descriptionText={item.description} />
      ))}
    </Fragment>
  );
};
